import { Component } from '@angular/core';

@Component({
  selector: 'app-rum-button',
  templateUrl: './rum-button.component.html',
  styleUrls: ['./rum-button.component.scss']
})
export class RumButtonComponent {

}
